export const schemaIconByName: { [name: string]: string } = {
    table_contact: 'custom_contacts',
    table_company: 'custom_companies',
    table_deal: 'custom_deals',
    Issues: 'custom_tasks',
}
